<template>
    <!-- <div
        class="p-dialog p-component"
        style="display: flex; flex-direction: column; pointer-events: auto; width: 50vw"
        role="dialog"
        aria-labelledby="pv_id_13_header"
        aria-modal="true"
        data-pc-name="dialog"
        data-pc-section="root"
        pv_id_7=""
        data-pd-focustrap="true"
    >
        <span class="p-hidden-accessible p-hidden-focusable" tabindex="0" role="presentation" aria-hidden="true" data-p-hidden-accessible="true" data-p-hidden-focusable="true" data-pc-section="firstfocusableelement"></span
        >
        <div class="p-dialog-content border-round-top p-0" data-pc-section="content">
            <div class="flex w-full surface-section align-items-center justify-content-between px-1">
                <span class="p-input-icon-left w-full"
                    ><i class="pi pi-search text-500"></i
                    ><input class="p-inputtext p-component w-full border-none shadow-none outline-none" data-pc-name="inputtext" data-pc-section="root" type="text" placeholder="Search menus, shortcuts, contact and more..." /></span
                ><span class="border-1 p-1 surface-border border-round surface-100 mr-2 text-600 text-xs hidden md:block">⌘K</span>
            </div>
            <div class="border-y-1 surface-border px-3 py-3">
                <h2 class="font-semibold text-xs text-500 mb-2 mt-0 px-1">RECENT</h2>
                <ul class="list-none m-0 p-0">
                    <li class="select-none p-2 font-medium text-base cursor-pointer border-round-lg hover:surface-hover hover:text-primary">unread mails</li>
                    <li class="select-none p-2 font-medium text-base cursor-pointer border-round-lg hover:surface-hover hover:text-primary">go to last mail</li>
                    <li class="select-none p-2 font-medium text-base cursor-pointer border-round-lg hover:surface-hover hover:text-primary">lock account</li>
                    <li class="select-none p-2 font-medium text-base cursor-pointer border-round-lg hover:surface-hover hover:text-primary">profile</li>
                </ul>
            </div>
            <div class="p-2">
                <article class="flex w-full justify-content-between align-items-center mb-3 select-none cursor-pointer surface-border hover:surface-hover border-round-lg px-2 py-1 text-800 hover:text-primary">
                    <div class="flex align-items-center">
                        <span class="border-circle w-2rem h-2rem flex align-items-center justify-content-center surface-100"><i class="pi pi-cog text-lg"></i></span>
                        <div class="ml-2">
                            <p class="font-semibold text-sm mt-0 mb-1">System Settings</p>
                            <p class="font-normal text-xs text-600 mt-0 mb-0">Change your system preferences</p>
                        </div>
                    </div>
                    <span class="hidden md:inline-block border-1 px-2 py-1 surface-border border-round surface-100 mr-2 text-600 text-xs">S</span>
                </article>
                <article class="flex w-full justify-content-between align-items-center mb-3 select-none cursor-pointer surface-border hover:surface-hover border-round-lg px-2 py-1 text-800 hover:text-primary">
                    <div class="flex align-items-center">
                        <span class="border-circle w-2rem h-2rem flex align-items-center justify-content-center surface-100"><i class="pi pi-user text-lg"></i></span>
                        <div class="ml-2">
                            <p class="font-semibold text-sm mt-0 mb-1">My Profile</p>
                            <p class="font-normal text-xs text-600 mt-0 mb-0">Go to your profile</p>
                        </div>
                    </div>
                    <span class="hidden md:inline-block border-1 px-2 py-1 surface-border border-round surface-100 mr-2 text-600 text-xs">P</span>
                </article>
                <article class="flex w-full justify-content-between align-items-center mb-3 select-none cursor-pointer surface-border hover:surface-hover border-round-lg px-2 py-1 text-800 hover:text-primary">
                    <div class="flex align-items-center">
                        <span class="border-circle w-2rem h-2rem flex align-items-center justify-content-center surface-100"><i class="pi pi-moon text-lg"></i></span>
                        <div class="ml-2">
                            <p class="font-semibold text-sm mt-0 mb-1">Switch to Dark Mode</p>
                            <p class="font-normal text-xs text-600 mt-0 mb-0">Switch to dark mode save your eyes</p>
                        </div>
                    </div>
                    <span class="hidden md:inline-block border-1 px-2 py-1 surface-border border-round surface-100 mr-2 text-600 text-xs">D</span>
                </article>
                <article class="flex w-full justify-content-between align-items-center select-none cursor-pointer surface-border hover:surface-hover border-round-lg px-2 py-1 text-800 hover:text-primary">
                    <div class="flex align-items-center">
                        <span class="border-circle w-2rem h-2rem flex align-items-center justify-content-center surface-100"><i class="pi pi-sign-out text-lg"></i></span>
                        <div class="ml-2">
                            <p class="font-semibold text-sm mt-0 mb-1">Log out</p>
                            <p class="font-normal text-xs text-600 mt-0 mb-0">End your session</p>
                        </div>
                    </div>
                </article>
            </div>
        </div>
        <span class="p-hidden-accessible p-hidden-focusable" tabindex="0" role="presentation" aria-hidden="true" data-p-hidden-accessible="true" data-p-hidden-focusable="true" data-pc-section="lastfocusableelement"></span>
    </div> -->
    <Dialog
        v-model:visible="visible"
        position="top"
        modal
        :pt="{
            root: 'border-none',
            mask: {
                style: 'backdrop-filter: blur(2px)'
            }
        }"
        :breakpoints="{ '1199px': '75vw', '575px': '90vw' }"
        :style="{ width: '75vw' }"
        :dismissableMask="true"
        @hide="onCloseModal"
    >
        <template #container="{ closeCallback }">
            <div class="flex flex-column px-5 py-5 gap-4 p-dialog-content" style="border-radius: 12px">
                <div class="flex w-full surface-section align-items-center justify-content-between px-1">
                    <span v-focustrap class="p-input-icon-left w-full">
                        <i class="pi pi-search text-500"></i>
                        <input class="p-inputtext p-component w-full border-none shadow-none outline-none" data-pc-name="inputtext" data-pc-section="root" type="text" :placeholder="`Cari di ${ $store.state.setting?.app_name }`" v-model="form.search" autofocus>
                    </span>
                    <span class="border-1 p-1 surface-border border-round surface-100 mr-2 text-600 text-xs hidden md:block">⌘K</span>
                </div>
                <div class="border-y-1 surface-border px-3 py-3" v-if="form.search">
                    <h2 class="font-semibold text-xs text-500 mb-2 mt-0 px-1">
                        Search: <b>{{ form.search }}</b>
                    </h2>
                    <div class="flex justify-content-center" v-if="isLoading">
                        <ProgressSpinner style="width: 50px; height: 50px" strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s" aria-label="Custom ProgressSpinner" />
                    </div>
                    <ul class="list-none m-0 p-0" v-if="results">
                        <li class="select-none p-2 font-medium text-base cursor-pointer border-round-lg hover:surface-hover hover:text-primary" v-for="product in results" :key="product">
                            <div class="flex w-full justify-content-between align-items-center mb-3 select-none cursor-pointer surface-border hover:surface-hover border-round-lg px-2 py-1 text-800 hover:text-primary">
                                <div class="flex align-items-center">
                                    <span class="border-circle w-2rem h-2rem flex align-items-center justify-content-center surface-100">
                                        <Image width="35" :src="product?.image_url" :alt="product?.name" />
                                    </span>
                                    <div class="ml-3">
                                        <p class="font-semibold text-sm mt-0 mb-1 mark-title" @click="redirectProductDetails(product?.slug)" v-html="highlightTextSearch(product?.name, form.search)"></p>
                                        <p class="font-normal text-xs text-600 mt-0 mb-0">Categorie: {{ product?.categorie?.name }}</p>
                                    </div>
                                </div>
                                <!-- <span class="hidden md:inline-block border-1 px-2 py-1 surface-border border-round surface-100 mr-2 text-600 text-xs">S</span> -->
                            </div>
                            <!-- <pre>{{ results }}</pre> -->
                        </li>
                        <!-- <li class="select-none p-2 font-medium text-base cursor-pointer border-round-lg hover:surface-hover hover:text-primary">go to last mail</li> -->
                        <!-- <li class="select-none p-2 font-medium text-base cursor-pointer border-round-lg hover:surface-hover hover:text-primary">lock account</li> -->
                        <!-- <li class="select-none p-2 font-medium text-base cursor-pointer border-round-lg hover:surface-hover hover:text-primary">profile</li> -->
                    </ul>
                </div>
                <div class="border-y-1 surface-border px-3 py-3" v-else>
                    <h2 class="font-semibold text-xs text-500 mb-2 mt-0 px-1">HAVE A NICE DAY!</h2>
                </div>
                <div class="p-2">
                    <article class="flex w-full justify-content-between align-items-center mb-3 select-none cursor-pointer surface-border hover:surface-hover border-round-lg px-2 py-1 text-800 hover:text-primary" @click="$router.push({ name: 'cart' })">
                        <div class="flex align-items-center">
                            <span class="border-circle w-2rem h-2rem flex align-items-center justify-content-center surface-100"><i class="pi pi-shopping-cart text-lg"></i></span>
                            <div class="ml-2">
                                <p class="font-semibold text-sm mt-0 mb-1">Cart</p>
                                <p class="font-normal text-xs text-600 mt-0 mb-0">View your carts</p>
                            </div>
                        </div>
                        <span class="hidden md:inline-block border-1 px-2 py-1 surface-border border-round surface-100 mr-2 text-600 text-xs">S</span>
                    </article>
                    <article class="flex w-full justify-content-between align-items-center mb-3 select-none cursor-pointer surface-border hover:surface-hover border-round-lg px-2 py-1 text-800 hover:text-primary" @click="$router.push({ name: 'profile' })">
                        <div class="flex align-items-center">
                            <span class="border-circle w-2rem h-2rem flex align-items-center justify-content-center surface-100"><i class="pi pi-user text-lg"></i></span>
                            <div class="ml-2">
                                <p class="font-semibold text-sm mt-0 mb-1">My Profile</p>
                                <p class="font-normal text-xs text-600 mt-0 mb-0">Go to your profile</p>
                            </div>
                        </div>
                        <span class="hidden md:inline-block border-1 px-2 py-1 surface-border border-round surface-100 mr-2 text-600 text-xs">P</span>
                    </article>
                    <article class="flex w-full justify-content-between align-items-center select-none cursor-pointer surface-border hover:surface-hover border-round-lg px-2 py-1 text-800 hover:text-primary" @click="onLogout">
                        <div class="flex align-items-center">
                            <span class="border-circle w-2rem h-2rem flex align-items-center justify-content-center surface-100"><i class="pi pi-sign-out text-lg"></i></span>
                            <div class="ml-2">
                                <p class="font-semibold text-sm mt-0 mb-1">Log out</p>
                                <p class="font-normal text-xs text-600 mt-0 mb-0">End your session</p>
                            </div>
                        </div>
                    </article>
                </div>
                <!-- <div class="inline-flex flex-column gap-2">
                    <label for="username" class="text-primary-50 font-semibold">Username</label>
                    <InputText id="username" class="bg-white-alpha-20 border-none p-3 text-primary-50 w-20rem"></InputText>
                </div>
                <div class="inline-flex flex-column gap-2">
                    <label for="password" class="text-primary-50 font-semibold">Password</label>
                    <InputText id="password" class="bg-white-alpha-20 border-none p-3 text-primary-50 w-20rem" type="password"></InputText>
                </div>
                <div class="flex align-items-center gap-3">
                    <Button label="Cancel" @click="closeCallback" text class="p-3 w-full text-primary-50 border-1 border-white-alpha-30 hover:bg-white-alpha-10"></Button>
                    <Button label="Sign-In" @click="closeCallback" text class="p-3 w-full text-primary-50 border-1 border-white-alpha-30 hover:bg-white-alpha-10"></Button>
                </div> -->
            </div>
        </template>
    </Dialog>
</template>

<script>
export default {
    name: 'AppSearchProduct',
    props: {
        search: Boolean
    },
    emits: ['close-modal'],
    data: () => ({
        visible: false,
        isLoading: false,
        form: {
            search: null
        },
        results: null
    }),
    methods: {
        redirectProductDetails(slug) {
            this.onCloseModal()
            this.$nextTick(() => {
                this.$router.push({ name: 'product-details', params: { slug: slug }})
            })
        },
        onCloseModal() {
            this.$emit('close-modal');
        },
        highlightTextSearch(text, search) {
            let r = new RegExp(search, 'i');
            let t = text.replace(r, `<span style="background: none; color: var(--green-500)">${search}</span>`);
            return t;
        },
        async onLogout() {
            try {
                await window.axios.get('/v1/auth/logout');
            } catch (err) {
                console.log('logout error', err)
            } finally {
                this.$nextTick(() => {
                    this.$router.push({
                        name: 'login'
                    });
                });
            }
        }
    },
    watch: {
        search: {
            immediate: true,
            deep: true,
            handler(value) {
                if (value) {
                    this.visible = value;

                    console.info('search visible', this.visible);
                }
            }
        },
        'form.search': async function (value) {
            if (value) {
                this.isLoading = true;
                try {
                    var {
                        data: {
                            data: { products }
                        }
                    } = await window.axios.get(`/v2/product?search=${value}`);

                    if (products.length > 0) {
                        this.results = products;
                    } else {
                        this.results = null;
                    }
                } catch ({ response: { data } }) {
                    if (Object.keys(data).includes('error')) {
                        var {
                            error: { message }
                        } = data;
                    } else {
                        var { message } = data;
                    }

                    console.error(message);
                } finally {
                    this.isLoading = false;
                }
            } else {
                this.results = null;
            }
        }
    }
};
</script>

<style scoped>
.p-input-icon-left,
.p-input-icon-right {
    position: relative;
    display: inline-block;
}

.p-input-icon-left > i,
.p-input-icon-left > svg,
.p-input-icon-right > i,
.p-input-icon-right > svg {
    position: absolute;
    top: 50%;
    margin-top: -0.5rem;
}

.p-input-icon-left > svg:first-of-type,
.p-input-icon-left > i:first-of-type {
    left: 0.75rem;
    color: #6b7280;
}

.p-input-icon-left > .p-inputtext {
    padding-left: 2.5rem;
}

.p-dialog-content {
    overflow-y: auto;
}

p.mark-title > mark {
    background: none;
    color: var(--green-100);
}

@media screen and (min-width: 992px) {
    .lg\:px-8 {
        padding-left: 5rem !important;
        padding-right: 5rem !important;
    }
}
</style>
